import { useEffect } from 'react';
import { getMUICache, appendStyleSheet, getImageId, getImageUrl, getImageSize, convertEpochTime, getListButtonIconPlain, fetchAnchorValue, isUpdatedWithin24Hours, GetFallBackImage } from './../../../common/utils';
// import Box from '@mui/material/Box';
// import Container from '@mui/material/Container';
// import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
// const DEFAULT_PLACEHOLDER = "https://static.toiimg.com/photo/42706777.gif";
import "./ListViewTwo.css";
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages, PreloadViewportImages, ImageLoader } from '../../../components/IntersectionObserver/imageComponent';

const Card = (props: any) => {
  const { item, isSimilarStories, isViewport, cardTextColor, cardColor, showDate, showAuthor, anchorLinksValue } = props;
  const { hl, syn, au, imageid, pubInfo, wu, upd, tn, du } = item;
  const cache = getMUICache();
  let styles = require("./ListViewTwo.css");
  appendStyleSheet("ListViewTwo", styles);
  AddImageDimensions();
  SetHighPriorityImages();
  PreloadViewportImages();
  ImageLoader();

  useEffect(() => {
    EagerLoadImages()
  }, []);

  let imageSize = getImageSize(imageid);

  return (
    <CacheProvider value={cache}>
      <a role="link" aria-label="Next Page" href={(wu?.startsWith('http') ? wu : (wu?.startsWith('/') ? wu : '/' + wu))} target={fetchAnchorValue(anchorLinksValue, (wu?.startsWith('http') ? wu : (wu?.startsWith('/') ? wu : '/' + wu)))} className='themeTwoListViewWraperAnchor' style={{backgroundColor: cardColor}}>
        <div className='themeTwoListViewWraper'>
          <div className='themeTwoListViewImageWraper'>

          {isSimilarStories
            ?
            (imageSize && isViewport ? <img width="110" height="83" alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)}  src={getImageUrl(getImageId(imageid), imageSize, 130, undefined, pubInfo.baseDomain, false, props.CONSTANTS)} />
              : (imageSize && !isViewport ? <img width="110" height="83" alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)}  src={getImageUrl(getImageId(imageid), imageSize, 130, undefined, pubInfo.baseDomain, false, props.CONSTANTS)} /> : null))
            :
              (imageSize ?
                (<picture>
                  {/* Add multiple source elements for different image sources */}
                  <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(imageid), imageSize, 212, '', pubInfo.baseDomain, false, props.CONSTANTS)} />
                  <source media="(max-width: 767px)" srcSet={getImageUrl(getImageId(imageid), imageSize, 120, '', pubInfo.baseDomain, false, props.CONSTANTS)} />
                  {/* Fallback image for browsers that do not support the picture element */}
                  {isViewport ? (<img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy" />)
                    : (<img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy" />)}
                </picture>)
                :
                <img src={GetFallBackImage()} alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy" />
              )
            }

            {(tn == "MEDIAAUDIO" || tn == "MEDIAVIDEO") &&
              <div className='themeTwoVideoListiconWrap'>
                <span className="VideoplayThemeTwoButton">{getListButtonIconPlain(tn)}</span><span className='videodu'>{du}</span>
              </div>
            }
          </div>

          <div className='themeTwoListViewContentWraper liveBlogHeadingBox listBlogWrapper'>
            <div className='themeTwoListViewTitle' style={{ color: cardTextColor }}>
              {item.tn === 'LIVEBLOG' && (
                <span className={`liveBlogCommonLiveHeading ${isUpdatedWithin24Hours(item?.lpt, item?.upd) ? "liveBlogAnimationHeading" : "liveBlogNoneAnimationHeading"}`}>
                  {isUpdatedWithin24Hours(item?.lpt, item?.upd) && (
                    <>
                      <i></i>
                      Live {' '}
                      <span style={{ margin: '0px 4px', color: '#000' }}>|</span>
                    </>
                  )}
                </span>
              )}
              {hl}
            </div>
            <div className='themeTwoListViewAuthWrap'>
              {showDate && <p className='themeTwoListViewDate commonListViewAuth'>{convertEpochTime(upd, 'updated', "DD MMM YYYY")}</p>}
              {(showAuthor && au != '') && <p className='themeTwoListViewAgency commonListViewAuth'>By <span className='manageAuthorName'>{au}</span></p>}
            </div>
            <div className='themeTwoListViewDiscription themeTwoListViewDiscriptionDesktop'>
              <p style={{ color: cardTextColor }}>{syn} </p>
            </div>
          </div>
        </div>

        <div className='themeTwoListViewDiscription themeTwoListViewDiscriptionMobile'>
          <p style={{ color: cardTextColor }}>{syn} </p>
        </div>
      </a>
      {/* </div>
          <div className='clearfix'></div>
        </div> 
      </div>*/}
    </CacheProvider>
  )
}
export default Card;